import React, { Component } from 'react';
import parse from 'html-react-parser';
import styled from 'styled-components';

import { Font, FontWeight } from '../../../utils/fonts';

import BorderButton from '../../BorderButton';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

class ItemContent extends Component {
    render() {
        const { className, content, onLookDecisionsButtonClick } = this.props;

        return (
            <Root className={className}>
                <Wrapper>
                    {
                        content.map((item, index) => (
                            <ItemBlock key={index.toString()}>
                                {
                                    parse(item)
                                }
                            </ItemBlock>
                        ))
                    }
                </Wrapper>
                <BorderButtonStyled onClick={() => onLookDecisionsButtonClick()}>
                    Смотреть решения
                </BorderButtonStyled>
            </Root>
        );
    }
}

const Root = styled.div``;

const Wrapper = styled.div`
    margin-bottom: 32px;
`;

const ItemBlock = styled.div`
    width: 100%;

    ${Font.REGULAR};
    ${FontWeight.REGULAR};
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, .64);

    padding-bottom: 24px;
    margin-bottom: 24px;

    border-bottom: 1px solid rgba(0, 0, 0, .16);
    word-break: break-word;

    &:last-child {
        border-bottom: 0px solid rgba(0, 0, 0, 0);
    }

    p {
        margin: 0px;
    }
`;

const BorderButtonStyled = styled(BorderButton)`
    width: 272px;
    height: 63px;

    background: #F5F5F5;

    ${mediaWidth.m} {
        width: 261px;
        height: 63px;
    }

    ${mediaWidth.l} {
        width: 282px;
        height: 63px;
    }

    ${mediaWidth.xl} {
        width: 406px;
        height: 71px;
    }
`;

export default ItemContent;
